import type { FulfillmentOrderLine, FulfillmentResourceMentionCandidate, FulfillmentWorkspace } from "../types";

/** 行程内的一次真实考察点到访。 */
export type TicketVisit = { id: string; pointSpuId: string; name: string; dayNo: number; date: string | null };

/** 从完整行程节点构建门票工作台，不依赖是否已录入费用。 */
export function buildTicketVisits(workspace: FulfillmentWorkspace): TicketVisit[] {
  const dates = new Map((workspace.routeDays ?? []).map(day => [day.dayNo, day.date]));
  const slots: Record<string, number> = { morning: 0, afternoon: 1, evening: 2 };
  return [...(workspace.itineraryPoints ?? [])]
    .sort((left, right) => left.dayNo - right.dayNo || (slots[left.timeSlot] ?? 3) - (slots[right.timeSlot] ?? 3) || left.sortOrder - right.sortOrder)
    .map(point => ({ id: point.nodeId, pointSpuId: point.pointSpuId, name: point.pointName, dayNo: point.dayNo, date: dates.get(point.dayNo) ?? null }));
}

/** 将行程点转换为门票规格查询所需的真实父资源候选。 */
export function pointCandidate(visit: TicketVisit): FulfillmentResourceMentionCandidate {
  return { resourceType: "考察点", level: "spu", mentionText: visit.name, spuTableName: "resource_point_spu", spuId: visit.pointSpuId, spuName: visit.name, skuTableName: null, skuId: null, skuName: null, description: null, transportMode: null, travelerRole: null };
}

/** 仅在真实资源和单一服务日期共同唯一匹配时关联已有费用。 */
export function ticketVisitForLine(line: FulfillmentOrderLine, visits: readonly TicketVisit[]): TicketVisit | undefined {
  if (line.resourceType !== "考察点") return undefined;
  const pointSpuId = line.resourceSelection?.kind === "point" ? line.resourceSelection.pointSpuId : line.spuTableName === "resource_point_spu" ? line.spuId : null;
  const dates = [...new Set(line.serviceDates?.length ? line.serviceDates : [line.serviceDateFrom, line.serviceDateTo].filter((date): date is string => Boolean(date)))];
  if (!pointSpuId || dates.length !== 1) return undefined;
  const matches = visits.filter(visit => visit.pointSpuId === pointSpuId && visit.date === dates[0]);
  return matches.length === 1 ? matches[0] : undefined;
}
